<template>
    <FestivalSection
        v-bind="filters"
        :color-theme="colorTheme"
    >
        <template #title>
            {{ title }}
        </template>
    </FestivalSection>
</template>

<script setup lang="ts">
import type { FlexibleFestivalBlockFragment } from '~/types/craft-schema';

const props = defineProps<FlexibleFestivalBlockFragment>();

const filters = useExtractFiltersFromCraftBundle(props.festivalBundle?.[0]);
</script>
